import axios, { API_URL } from '@propertypal/shared/src/services/axios';
import { SiteMapGlobalResponseType } from '@propertypal/shared/src/types/siteMap';
import platform from '@propertypal/shared/src/utils/platform';
import SiteMapGlobal from '@propertypal/web-ui/src/site-map/SiteMapGlobal';
import Head from 'next/head';
import { GetServerSideProps, GetServerSidePropsContext } from 'next/types';
import React, { FunctionComponent } from 'react';
import { Dispatch } from 'redux';
import generateMetaTags from '../components/layout/MetaTags';
import { requireAuthToken } from '../utils/auth';

interface Props {
  data: SiteMapGlobalResponseType;
}

const getSiteMapData = async (dispatch: Dispatch, ctx?: GetServerSidePropsContext) => {
  const result = await axios(
    {
      method: 'GET',
      url: `${API_URL}/site-map`,
    },
    dispatch,
    ctx,
  );

  return result.data;
};

export const getServerSideProps: GetServerSideProps = requireAuthToken(async (ctx, store) => {
  const data = await getSiteMapData(store.dispatch, ctx);

  return {
    props: {
      data,
    },
  };
});

const SiteMap: FunctionComponent<Props> = (props) => {
  return (
    <>
      <Head>
        {generateMetaTags({
          title: `${platform.title} Sitemap`,
          url: `/site-map`,
        })}
      </Head>

      <SiteMapGlobal data={props.data} />
    </>
  );
};

export default SiteMap;
